<template>
  <detail-layout-two-columns-no-fixed-collapsible :custom-right="summaryWidth" :collapsed="collapsed" @update:collapsed="$emit('update:collapsed', $event)">
    <template slot="header">
      <slot name="header" />
      <div class="px-4 lg:px-10 font-medium dark:text-white mb-2 flex gap-4 items-center">
        <h2>{{ step.description }}</h2>
      </div>   
    </template>

    <template slot="LeftCol">
      <div class="form-wrapper px-4 lg:px-10 overflow-x-auto overflow-y-auto">
        <el-form class="flex flex-row w-full md:w-11.5/12 lg:max-w-detailinvoice" :model="paymentMethod" ref="ruleForm" :rules="rules">
          <div class="flex-1">

            <div class="flex flex-col lg:flex-row lg:mb-2 gap-x-6">
              <div class="w-full" >
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('invoices.invoices_issuing.step6.payment_method') }}</label>
                  <el-form-item prop="formaPago" class="w-full">
                    <el-form-item prop="tipoAsociado">
                      <base-el-select class="w-full"  v-model="paymentMethod.formaPago" :options="formasPago" />
                    </el-form-item>
                  </el-form-item>
              </div>
            </div>

            <div v-if="isRequired">
              <div class="lg:mb-2">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('agenda.cuenta_bancaria') }}</label>
                <el-form-item prop="account">
                  <base-el-select v-if="paymentMethod.formaPago === '02'" v-model="paymentMethod.account" value-key="IdBankAccount" :options="cuentasSociedad" :option-value="optionValue" :option-label="accountOptionLabel" />
                  <base-el-select v-else v-model="paymentMethod.account" value-key="IdCuentaBancaria" :options="cuentasEmpresa" :option-value="optionValue" :option-label="accountOptionLabel" />
                </el-form-item>
              </div>
            </div>
            
            <div class="flex flex-col lg:flex-row lg:mb-2 gap-x-6">
              <div>
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('SEPA.due_date') }}</label>
                <el-form-item prop="dateVencimiento">
                  <el-date-picker v-model="paymentMethod.dateVencimiento" type="date" :picker-options="dateRangeOptions"
                    :disabled="paymentMethod.formaPago === '01'" :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]"></el-date-picker>
                </el-form-item>
              </div>
            </div>

            <base-collapsible-switch-form v-if="isTransferencia" ref="baseCollapsibleCesionario" v-model="paymentMethod.useCesionario" :disabled="!cesionarios.length" @input="autoselectCesionario" @clearForm="resetCesionario"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <div class="flex gap-4 items-center flex-1">
                  <div class="flex gap-2 items-center">
                    <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{ $t('tipos.rol_agenda.assignee_short') }}</h4>
                    <base-tooltip-icon v-if="!cesionarios.length" class="cursor-default" :content="$t('tooltip.agenda.no_assignees_available')" @click.stop />
                  </div>
                  <!-- <el-form-item v-if="paymentMethod.useCesionario" prop="useCesionario" class="w-full absolute mt-6 pt-2" /> -->
                </div>
              </template>
              <template slot="content">
                <el-form-item prop="cesionario">
                  <base-el-select v-model="paymentMethod.cesionario" value-key="IdCesionario" :options="cesionarios" :option-value="optionValue" :option-label="cesionarioOptionLabel" />
                </el-form-item>
                <el-form-item prop="cesionarioAccount">
                  <base-el-select v-model="paymentMethod.cesionarioAccount" value-key="IdCuentaBancaria" :options="cuentasCesionarios" :option-value="optionValue" :option-label="accountOptionLabel" :disabled="!paymentMethod.cesionario" />
                </el-form-item>
              </template>
            </base-collapsible-switch-form>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="RightCol">
      <slot name="invoice-summary" />
    </template>
    <template slot="layout-extend">
      <slot name="layout-extend" :valid="isValid" />
    </template>
  </detail-layout-two-columns-no-fixed-collapsible>
</template>

<script>
import moment from 'moment'
import { i18n } from '@/i18n'
import { IBAN as ibanRegex, bicSwift as bicSwiftRegex } from '@/utils/regex'
// import { TIPOS_FILTER_MULTIPLE } from '@/config/tipos-filter'

// import { getInvoicePayment } from '@/services/app/getInvoicePayment'
import getLocaleDateTimeFormat from '@/services/functions/getLocaleDateTimeFormat'
import { getLastBankAccount } from '@/services/configurations/getLastBankAccount'
import { getBankAccounts } from '@/services/companies/getBankAccounts'
import { getSedesBankAccounts } from '@/services/configurations/getSedesBankAccounts'

import DetailLayoutTwoColumnsNoFixedCollapsible from '@/components/layout/DetailLayoutTwoColumnsNoFixedCollapsible.vue'
import { getSociedadesSedesExt } from '@/services/configurations/getSociedadesSedesExt'


function isValidIBAN (value) {
  return value.split(';').every(item => ibanRegex.test(item))
}

function isValidBicSwift (value) {
  return value.split(';').every(item => bicSwiftRegex.test(item))
}


export default {
  name: 'step6-payment',
  components: {
    // Loading,
    DetailLayoutTwoColumnsNoFixedCollapsible
  },
  props: {
    step: Object,
    value: [Number, String],
    isFirstStep: {
      type: Boolean,
      default: false
    },
    summaryWidth: {
      type: [Array, Object, String],
      default: 'w-full'
    },
    collapsed: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      stepId: '6',
      // All
      showModalGrouping: false,
      loadingExcel: false,
      spanish: true,
      showModal: false,
      vuexnamespace: 'invoicesIssuing/6',
      maxLengthIBAN: 40,
      maxLengthBicSwift: 15,
      showCesionario: false,
      cesionarios: [],
      cuentasEmpresa: [],
      cuentasSociedad: [],
      cuentasCesionarios: [],
      valueFormat: 'yyyy-MM-DD[T00:00:00]',
      dateRangeOptions: {
        firstDayOfWeek: 1,
        disabledDate: this.disabledVencimientoDates,
        shortcuts: []
      },
      rules: {
        formaPago: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'] 
          }
        ],
        account: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'] 
          }
        ],
        dateVencimiento: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          }
        ],
      },
    }
  },
  computed: {
    isValid: function () {
      return this.paymentMethod.formaPago && this.paymentMethod.dateVencimiento && (!this.isRequired || this.paymentMethod.account)
    },
    form: function () {
      return this.$store.getters[this.vuexnamespace + '/form']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading || this.loadingCompanies || this.loadingCompanyData || this.loadingContacts
    },
    issuingForm: function () {
      return this.$store.getters['invoicesIssuing/form']
    },
    paymentMethod: function () {
      return this.issuingForm.paymentMethod
    },
    datePattern () {
      const formatKey = 'numeric_date'
      const locale = i18n.locale || 'es'
      return getLocaleDateTimeFormat(formatKey, locale)
    },
    formasPago: function () {
      return this.$store.getters['config/FORMAS_DE_PAGO']
    },
    isRequired: function () {
      return ['02', '04'].includes(this.paymentMethod.formaPago)
    },
    isDomiciliado: function () {
      return ['02'].includes(this.paymentMethod.formaPago)
    },
    isTransferencia: function () {
      return ['04'].includes(this.paymentMethod.formaPago)
    },
    hasCesionarios: function () {
      return !!this.cesionarios.length
    },
    getAuxIdParams: function () {
      return {
        idCIFEmpresa: this.issuingForm.issuer.IdCIFEmpresa,
        idSociedad: this.issuingForm.receiver.IdSociedad,
        idSede: this.issuingForm.receiver.IdSede
      }
      // return params
    },
    defaultDate: function () {
      return moment.max(moment(this.issuingForm.dateEmision).startOf('day'), moment().startOf('day'))
    }
  },
  async mounted () {
    this.paymentMethod.dateVencimiento = this.defaultDate.format(this.valueFormat)
    const shortcuts = [0, 15, 30, 45, 60, 90]
    shortcuts.forEach(shortcut => this.dateRangeOptions.shortcuts.push({
      text: i18n.tc('app.n_days', shortcut),
      onClick: picker => this.pickShortcut(picker, shortcut)
    }))
    Promise.all([
      this.getLastPaymentMethod(),
      this.getCompanysBankAccounts(),
      this.getSedesBankAccounts(),
      this.getCesionarios()
    ])
  },
  watch: {
    'paymentMethod.formaPago': function (value, oldValue) {
      if (value !== oldValue) {
        this.resetCesionario()
        let accounts = []
        if (value === '02') {
          accounts = this.cuentasSociedad
        } else if (value === '04') {
          accounts = this.cuentasEmpresa
        }
        this.$nextTick(() => { this.paymentMethod.account = accounts.find(x => x.DefaultBankAccount) || accounts[0] || '' })
        this.paymentMethod.dateVencimiento = this.defaultDate.format(this.valueFormat)
      }
    },
    'paymentMethod.cesionario': function (value, oldValue) {
      if (value !== oldValue) {
        if (value) {
          this.getCesionariosBankAccounts(value.IdSociedad, value.IdSede).then(() => {
            this.paymentMethod.cesionarioAccount = this.cuentasCesionarios.find(x => x.DefaultBankAccount) || this.cuentasCesionarios[0] || ''
          }) 
        } else {
          this.cuentasCesionarios = []
          this.paymentMethod.cesionarioAccount = ''
        }
      }
    }
  },
  methods: {
    disabledVencimientoDates (date) {
      const dateEmision = this.defaultDate
      const selected = moment(date).startOf('day')
      return selected.isBefore(dateEmision)
    },
    pickShortcut: function (picker, adddays) {
      const date = this.defaultDate.add(adddays, 'days').toDate()
      if (!this.disabledVencimientoDates(date)) {
        picker.$emit('pick', date)
      }
    },
    getLastPaymentMethod: async function () {
      if (this.paymentMethod.formaPago === '') {
        const data = await getLastBankAccount(this.getAuxIdParams)
        if (data.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
        }

        this.form.paymentMethod.formaPago = data.respuesta?.PaymentType || ''
        // this.form.paymentMethod.iban = data.respuesta?.IBANAccountNumber || ''
        // this.form.paymentMethod.bicSwift = data.respuesta?.BIC || ''
        // this.form.paymentMethod.fecha = data.respuesta?.MandatoryDate || ''
      }
    },
    getCompanysBankAccounts: async function () {
      const data = await getBankAccounts(this.getAuxIdParams)
      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      }
      this.cuentasEmpresa = data.respuesta || []
    },
    getSedesBankAccounts: async function () {
      const data = await getSedesBankAccounts(this.getAuxIdParams)
      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      }
      this.cuentasSociedad = data.respuesta || []
    },
    getCesionarios: async function () {
      const data = await getSociedadesSedesExt({ idCliente: this.issuingForm.issuer.IdCliente, idCIFEmpresa: this.issuingForm.issuer.IdCIFEmpresa, rolAgenda: 4 })
      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      }
      const response = data.respuesta || []
      response.forEach(cesionario => {
        if (!cesionario.IdCesionario) {
          const { IdSociedad, IdSede } = cesionario
          cesionario.IdCesionario = `${IdSociedad}-${IdSede}`
        }
      })
      this.cesionarios = response
    },
    getCesionariosBankAccounts: async function (idSociedad, idSede) {
      const data = await getSedesBankAccounts({ idSociedad, idSede })
      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      }
      this.cuentasCesionarios = data.respuesta || []
    },
    autoselectCesionario: function (value) {
      if (value) {
        this.paymentMethod.cesionario = this.cesionarios[0] || ''
      }
    },
    optionValue: function (option) {
      return option
    },
    accountOptionLabel: function (option) {
      if (option.BankAccountAlias && option.BankAccountAlias !== option.IBANAccountNumber) {
        return `${option.BankAccountAlias} (${option.IBANAccountNumber})`
      }
      return option.IBANAccountNumber
    },
    cesionarioOptionLabel: function (option) {
      return option.Sociedad.NameCorporateName || option.LocationName
    },
    validate: function (callback = (valid) => {}, doInput = true) {
      this.$refs.ruleForm.validate(valid => {
        if (valid && doInput && (this.isFirstStep || this.value === '') && [3, 7, 8].includes(this.role)) {
          this.$emit('input', this.selected[0]?.idCliente ?? '')
        }
        callback(valid) 
      })
    },
    resetForm (excluded = []) {
      if (!excluded.includes(this.stepId)) {
        this.$store.dispatch(this.vuexnamespace + '/resetForm')
      }
    },
    resetCesionario: function () {
      this.paymentMethod.cesionario = ''
      this.paymentMethod.cesionarioAccount = ''
    },
    isNameRequired: function (rule, value, callback) {
      if (this.form.paymentMethod.nombreCuenta) {
        callback()
      } else if (!value) {
        if (!this.isRequired) {
          callback()
        } else {
          callback(new Error(i18n.t('validation.complete')))
        }
      } 
    },
    isIBANValid: function (rule, value, callback) {
      if (!this.isRequired) {
        if (!value) {
          callback()
        } else {
          if (this.form.paymentMethod.toBeCredit && !isValidIBAN(value)) {
            callback(new Error(i18n.t('invoices.invoices_issuing.IBAN_regex')))
          } else if (value.length > this.maxLengthIBAN) {
            callback(new Error((i18n.t('validation.length_max', { maxLength: this.maxLengthIBAN }))))
          } else {
            callback()
          }
        }
      } else if (this.isRequired) {
        if (!value) {
          callback(new Error(i18n.t('validation.complete')))
        } else if (this.form.paymentMethod.toBeCredit) {
          if (!isValidIBAN(value)) {
            callback(new Error(i18n.t('invoices.invoices_issuing.IBAN_regex')))
          } else if (value.length > this.maxLengthIBAN) {
            callback(new Error((i18n.t('validation.length_max', { maxLength: this.maxLengthIBAN }))))
          } else {
            callback()
          }
        } else {
          // Condiciones de validación para número de cuenta
          callback()
        }
      }
    },
    isBicSwiftvalid: function (rule, value, callback) {
      if (!value) {
        callback()
      } else if (!isValidBicSwift(value)) {
        callback(new Error(i18n.t('invoices.invoices_issuing.swift_regex')))
      } else if (value.length > this.maxLengthBicSwift) {
        callback(new Error((i18n.t('validation.length_max', { maxLength: this.maxLengthBicSwift }))))
      } else {
        callback()
      }
    },
  },
}
</script>
<style scoped>
  .switchCredit{
    margin: unset;
    padding: unset;
  }
  .layout-detail::v-deep > .content {
    width: 100% !important;
  }
  .layout-detail::v-deep > .content > div > div {
    padding-inline: 0 !important;
  }
</style>
<style>
.cursor-default {
  cursor: default;
}
</style>
